import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Angulartics2 } from "angulartics2";

@Component({
  selector: "app-error-server-failure",
  templateUrl: "./server-failure.component.html",
  styleUrls: ["./server-failure.component.scss"]
})
export class ErrorServerFailureComponent implements OnInit {

  constructor(
    protected _analytics: Angulartics2,
    protected _activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    // TODO: Add refresh button on this component

    // Timeout to allow the URL to update on the next tick
    window.setTimeout(() => {
      this._analytics.eventTrack.next({
        action: this._activatedRoute.snapshot.params.code || "5xx",
        properties: {
          category: "Error",
          // TODO: Use Angular instead of window.*, see: handleResolverError
          label: window.location.pathname.replace(/[0-9a-f]{8}\-(?:[0-9a-f]{4}\-){3}[0-9a-f]{12}/gi, "{guid}"),
        },
      });
    }, 1);
  }

}
